import { createStore } from 'vuex';

const store = createStore({
    state: {
        loading: false,
        isUpdateAvailable: false,
    },
    getters: {
        getLoadingState: (state) => state.loading,
        getUpdateAvailability: (state) => state.isUpdateAvailable,
        currentDate: () => {
            let date = new Date();
            return date.toISOString().split('T')[0];
        },
        currentTime: () => {
            let date = new Date();
            let d = date.toISOString().split('T')[0];
            let hour = date.getHours() < 10 ? '0' + date.getHours() : date.getHours();
            let minute = date.getMinutes() < 10 ? '0' + date.getMinutes() : date.getMinutes();
            let t = hour + ':' + minute;
            return d + `T` + t;
        },
    },
    mutations: {
        setLoadingState: (state, payload) => state.loading = payload,
        setUpdateAvailability: (state, payload) => state.isUpdateAvailable = payload,
    },
    actions: {},
    modules: {},
});

export default store;
